import type { User } from 'firebase/auth';

/**
 * Shared admin allowlist, used by AdminLogin (sign-in gate) and by
 * ProtectedRoute in App.tsx (route gate). Single source of truth so the
 * two checks can never drift apart again.
 *
 * SECURITY NOTES:
 * - Every entry MUST be lowercase: emails are compared after
 *   `email.toLowerCase()`, which is what previously locked the primary
 *   admin out (mixed-case entry could never match).
 * - This allowlist ships in the client bundle, so it is a routing/UX
 *   convenience, NOT a security boundary — anyone can read or spoof it.
 *   The real data barrier is the Firebase RTDB security rules.
 *   The correct long-term fix is a server-side Firebase Auth custom claim
 *   (`admin: true`) granted from a trusted backend and verified with
 *   `user.getIdTokenResult().claims.admin`. This project has no backend,
 *   so the email allowlist is kept as a temporary measure.
 */
export const ADMIN_EMAILS: readonly string[] = [
  'yacoub.faik@gmail.com',
  'abdelmoughitezinebi@gmail.com',
  'upsicast@gmail.com',
  'mehdidehri2012@gmail.com'
];

export const isAdminEmail = (email: string | null | undefined): boolean => {
  if (!email) return false;
  return ADMIN_EMAILS.includes(email.toLowerCase());
};

export const isAdminUser = (user: User | null): boolean =>
  Boolean(user && isAdminEmail(user.email));
